<script setup lang="ts">
import type { SuggestionsGroupsProps } from "./SuggestionsGroups.props"

const props = defineProps<SuggestionsGroupsProps>()

const { t } = useI18n()

const emit =
  defineEmits<{
    (e: "clickRecent", text: string): void
    (e: "clickPopular", text: string): void
    (e: "clickBrand", text: string): void
    (e: "clickSuggestions", text: string): void
  }>()
</script>

<template>
  <SearchUtilsSuggestions
    v-if="queryState.length <= 2 && lastSearch?.length"
    class="col-span-1"
    :title="t('searchbar.labelLastSearchs')"
    :suggestions="lastSearch"
    @click="emit('clickRecent', $event.text)"
  />
  <SearchUtilsSuggestions
    v-if="
      queryState.length <= 2 &&
      lastSearch?.length == 0 &&
      querySuggestions?.length
    "
    class="col-span-1"
    :title="t('searchbar.popularSearch')"
    :suggestions="querySuggestions"
    @click="emit('clickPopular', $event.text)"
  />
  <SearchUtilsSuggestions
    v-if="queryState.length <= 2 && brandSuggestions?.length"
    class="col-span-1"
    :title="t('searchbar.popularBrands')"
    :suggestions="brandSuggestions"
    @click="emit('clickBrand', $event.text)"
  />
  <SearchUtilsSuggestions
    v-if="queryState.length <= 2 && categorySuggestions?.length"
    class="col-span-2"
    :title="t('searchbar.popularCategories')"
    :suggestions="categorySuggestions"
  />

  <SearchUtilsSuggestions
    v-if="suggestions?.length"
    :title="t('searchbar.suggestions')"
    :suggestions="suggestions"
    @click="emit('clickSuggestions', $event.text)"
  />
  <SearchUtilsSuggestions
    v-if="brandSearchSuggestions?.length"
    :title="t('searchbar.brands')"
    class="relative z-10"
    :suggestions="brandSearchSuggestions"
    @click="emit('clickBrand', $event.text)"
  />
  <SearchUtilsSuggestions
    v-if="categorySearchSuggestions?.length"
    class="col-span-2"
    :title="t('searchbar.categories')"
    :suggestions="categorySearchSuggestions"
  />
</template>
